import React, { Dispatch, FC, SetStateAction, useEffect, useMemo, useState } from 'react';
import { Modal } from '../../components/modal/modal.index';
import { Divider } from 'antd';
import { OrderTransaction, Transaction, OrderTransactionDetail } from '../../../interfaces';
import { get, getOrderTransactionBadgeType, getTransactionBadgeType } from '../../../scripts';
import { API } from 'data/30pay.api';
import { OrderTransactionDetailModal } from './detail/orderTransaction.index';
import { TransactionDetailModal } from './detail/transaction.index';

interface Props {
    item: OrderTransaction | Transaction;
    open: boolean;
    setOpen: Dispatch<SetStateAction<boolean>>;
}

export const ReportDetailModal: FC<Props> = ({ open, setOpen, item }) => {
    const [loading, setLoading] = useState<boolean>(false);
    const [details, setDetails] = useState<OrderTransactionDetail | null>(null);

    // Stable and safe check: must be string, non-null
    const isOrderTransaction = useMemo(() => {
        return (
            'orderTransactionTrackingCode' in item &&
            typeof item.orderTransactionTrackingCode === 'string' &&
            item.orderTransactionTrackingCode.trim().length > 0
        );
    }, [item]);

    useEffect(() => {
        if (open && isOrderTransaction && (item as OrderTransaction).orderTransactionTrackingCode !== null) {
            fetchOrderTransactionDetails((item as OrderTransaction).orderTransactionTrackingCode as string);
        }
    }, [open, isOrderTransaction, item]);

    const [lastFetchedCode, setLastFetchedCode] = useState<string | null>(null);

    const fetchOrderTransactionDetails = (trackingCode: string) => {
        if (trackingCode === lastFetchedCode) return;

        setLastFetchedCode(trackingCode);
        setLoading(true);
        get<OrderTransactionDetail>(API.orderTransaction.getByTrackingCode(trackingCode))
            .then((response) => {
                setDetails(response.value.value);
            })
            .catch((err) => console.log(err))
            .finally(() => setLoading(false));
    };

    return (
        <Modal destroyOnClose open={open} setOpen={setOpen} title="جزئیات سفارش" loading={loading}>
            <Divider />
            {isOrderTransaction && details ? (
                <OrderTransactionDetailModal open={open} setOpen={setOpen} item={details} />
            ) : (
                <TransactionDetailModal open={open} setOpen={setOpen} item={item as Transaction} />
            )}
        </Modal>
    );
};
